import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings',
  'CatalogService',
  '$uibModal',
  '$timeout',
  'CartService'
];

class MostSelledProductsController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.CatalogService  = CatalogService;
    this.CartService = CartService;
    this.$timeout = $timeout;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }

  $onInit(){
    this.getMostSelledProducts();
  }

  getMostSelledProducts() {
    let userId = '';
    try{ userId = this.shCtrl.currentUser.userId; }
    catch(e){}
    this.CatalogService.getMostSelledProducts(userId, 10).then(response => {
      this.mostSelledProducts = response;
      this.mostSelledProducts1 = [];
      this.mostSelledProducts2 = [];
      if(response.length){
        response.forEach((valFor, indexFor) => {
          if(indexFor <= ((response.length - 1) / 2) || response.length < 8) {
            this.mostSelledProducts1.push(valFor);
          } else {
            this.mostSelledProducts2.push(valFor);
          }
        });
      }
      this.initMostSelledCarousel();
      // initBrandsCarousel();

      this.loadingRelatedProducts = false;
    }).catch(error => {

    });
  }
  
  initMostSelledCarousel() {
    this.$timeout(function(){
      let mostSelledItems = $('.most-selled-items-slider.owl-carousel');
      mostSelledItems.owlCarousel({
        items: 4,
        itemsDesktop : [1199,3],
        itemsDesktopSmall: [979,2],
        itemsTablet: [768,2],
        itemsMobile : [479,1],
        slideSpeed: 400,
        autoPlay: 8000,
        stopOnHover: true,
        navigation: false,
        pagination: false,
        responsive: true,
        mouseDrag: true,
        autoHeight : true
      }).data('navigationBtns', ['#most-selled-items-slider-prev', '#most-selled-items-slider-next']);
      mostSelledItems.each(function() {
        let $this = $(this),
          owlCarousel = $this.data('owlCarousel'),
          owlBtns = $this.data('navigationBtns'),
          prevBtn, nextBtn;
        if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
          return;
        }
        for(let key in owlBtns) {
          if (owlBtns[key].indexOf('next') === -1) {
            prevBtn = $(owlBtns[key]);
          }else {
            nextBtn = $(owlBtns[key]);
          }
        }

        prevBtn.on('click touchstart', function(e) {
          owlCarousel.prev();
          e.preventDefault();
        });

        nextBtn.on('click touchstart', function(e) {
          owlCarousel.next();
          e.preventDefault();
        });
      });

      $('.add-tooltip').tooltip();
    },1000);
  }

  setItemToAddToCart(product) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalQuantityCart,
      controller : 'ModalQuantityCartController',
      controllerAs : 'mdCtrl',
      size: 'sm',
      resolve : {
        product : () => product
      }
    });
    modalInstance.result.then(result => {
      if(result.product.id && result.quantity){
        let userId = '', cart = null;
        try {userId = this.shCtrl.globals.currentUser.userId;}catch (e) {}
        try {cart = this.shCtrl.cart;}catch (e) {}
        this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
          if (!response.error) {
            this.$scope.$emit('onUpdateCart');
            let modalInstance2 = this.$uibModal.open({
              animation: true,
              template: modalConfirmationCart,
              controller : 'ModalConfirmationController',
              controllerAs : 'mdCtrl',
              size: 'lg',
              resolve : {
                product : () => product
              }
            });
          } else {
            let options = {
              title : '',
              isHtml : true,
              content : response.message,
              size : '',
              showBottonCancel : false,
              textActionCancel : '',
              textAction : 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          let options = {
            title : '',
            isHtml : false,
            content : reason,
            size : '',
            showBottonCancel : false,
            textActionCancel : '',
            textAction : 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }).catch(error => {
    
    });
  }

  updateFavoriteProducts (product) {
    product.isSettingAsFavorite = true;
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    if(userId) {
      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };
      this.CatalogService.updateFavoriteProducts(data).then(response => {
        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;
      }).catch(error => {
        product.isSettingAsFavorite = false;
        let options = {
          title : '',
          isHtml : false,
          content : 'Ha ocurrido un error al actualizar el producto',
          size : '',
          showBottonCancel : false,
          textActionCancel : '',
          textAction : 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }

}

MostSelledProductsController.$inject = inject;

export default MostSelledProductsController;




// WEBPACK FOOTER //
// ./www/components/catalog/most-selled-products/most-selled-products.controller.js